import { useCallback, useRef } from "react";
import { GetContaChatHistoricoPorTelefoneController } from "../../../Controllers/HelpDesk/ContaChatHistorico/ContaChatHistoricoControllers";
import {
    IChat,
    IMensagem,
} from "../../../Interfaces/HelpDesk/Equipes/Atendimento/AtendimentoInterfaces";

import Chats from "./Chats";
import { Conversa } from "./Conversa";

import "./styles.css";

export default function AtendimentoHelpDesk() {
    const ChatHistoricoMapRef = useRef(new Map<string, Array<IMensagem>>());
    const getChatHistorico = useCallback(async (nrTelefone: string) => {
        if (ChatHistoricoMapRef.current.has(nrTelefone))
            return ChatHistoricoMapRef.current.get(
                nrTelefone
            ) as Array<IMensagem>;
        else {
            const contaChatHistorico =
                await GetContaChatHistoricoPorTelefoneController(
                    nrTelefone
                ).then((res) =>
                    res.map(
                        (cch) =>
                            ({
                                Body: cch.DS_HISTORICO,
                                IdContaChat: cch.ID_CONTA_CHAT,
                                IdUsuario: cch.ID_USUARIO,
                                MediaContentType0: cch.DS_CONTENT_TYPE,
                                MediaUrl0: cch.DS_URL,
                                MensagemCliente: !cch.FL_USUARIO,
                                TimeStamp: new Date(cch.DT_HISTORICO).getTime(),
                                TimeStampSync: true,
                            } as IMensagem)
                    )
                );
            ChatHistoricoMapRef.current.set(nrTelefone, contaChatHistorico);
            return contaChatHistorico;
        }
    }, []);

    const updateChatHistoricoMap = useCallback((lstChats: Array<IChat>) => {
        const tempMap = new Map<string, Array<IMensagem>>();
        lstChats.forEach((chat) => {
            if (ChatHistoricoMapRef.current.has(chat.NumeroCliente))
                tempMap.set(
                    chat.NumeroCliente,
                    ChatHistoricoMapRef.current.get(
                        chat.NumeroCliente
                    ) as Array<IMensagem>
                );
        });
        ChatHistoricoMapRef.current = tempMap;
    }, []);

    return (
        <div className="w-100 h-100">
            <div className="container-fluid p-0 h-100">
                <div className="p-0 m-0 row h-100">
                    <div
                        className="col-12 col-lg-4 align-items-center collapse chatsContainer mb-5 mb-lg-0"
                        id="collapseChatInMobile"
                    >
                        <Chats onChatsUpdate={updateChatHistoricoMap} />
                    </div>
                    <div className="flex-row-fluid col-12 col-lg-8 conversaContainer">
                        <Conversa
                            getMensagensContaChatHistorico={getChatHistorico}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
